import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import http from '../components/http/http';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [details, setDetails] = useState<string[] | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setDetails(null);
    setSuccess(null);
    setLoading(true);
    try {
      const data = await http.post('/api/users/auth/forgot-password', { email });
      if (!data.success) {
        setError((data.errors && data.errors.join(', ')) || data.error || data.message || 'Request failed');
        setDetails(data.details || null);
        setLoading(false);
        return;
      }
      setSuccess(data.message || 'If an account with this email exists, a password reset email will be sent');
      setLoading(false);
    } catch (err: any) {
      setError('Network error');
      setDetails(null);
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fff' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontFamily: 'Roboto, sans-serif' }}>Forgot password</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Email<br />
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: 8, marginTop: 4, fontSize: 14 }}
              disabled={!!success}
            />
          </label>
        </div>
        {error && <div style={{ color: 'red', marginBottom: details ? 4 : 16 }}>{error}</div>}
        {details && details.length > 0 && (
          <ul style={{ color: 'red', marginBottom: 16, marginTop: 0, paddingLeft: 20 }}>
            {details.map((d, i) => <li key={i}>{d}</li>)}
          </ul>
        )}
        {success && <div style={{ color: 'green', marginBottom: 16, textAlign: 'center', lineHeight: '1.5' }}>{success}</div>}
        {!success && (
          <div style={{ marginBottom: 16 }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: 10,
                background: '#3baab0',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                fontWeight: 600,
                fontSize: 16,
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s',
                opacity: loading ? 0.7 : 1
              }}
              onMouseOver={e => (e.currentTarget.style.background = '#329a9e')}
              onMouseOut={e => (e.currentTarget.style.background = '#3baab0')}
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </div>
        )}
      </form>
      <div style={{ textAlign: 'center', marginTop: 24 }}>
        <Link to="/login">
          <button
            style={success ? {
              padding: '8px 20px',
              background: '#3baab0',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              transition: 'background 0.2s',
              whiteSpace: 'nowrap'
            } : {
              padding: '8px 20px',
              background: '#fff',
              color: '#3baab0',
              border: '2px solid #3baab0',
              borderRadius: 4,
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              transition: 'background 0.2s, color 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseOver={e => {
              if (success) {
                e.currentTarget.style.background = '#329a9e';
                e.currentTarget.style.color = '#fff';
              } else {
                e.currentTarget.style.background = '#3baab0';
                e.currentTarget.style.color = '#fff';
              }
            }}
            onMouseOut={e => {
              if (success) {
                e.currentTarget.style.background = '#3baab0';
                e.currentTarget.style.color = '#fff';
              } else {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = '#3baab0';
              }
            }}
          >
            Back to login
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword; 